module.exports = __webpack_public_path__ + "assets/img/report-design-1.cd30d7ec.png";